import React, { useState, useEffect } from "react";
import { useGlobalContext } from "../../../../Context/GlobalContext";
import {
  fetchAttendanceDetail,
  fetchDepartments,
  fetchFineDetails,
  fetchOverTimeDetails,
} from "../../../../components/attendance/api";
import DepartmentList from "../../../../components/attendance/DepartmentList";
import Header from "../../../../components/attendance/Header";
import OtherDepartments from "../../../../components/attendance/OtherDepartments";
import ClipLoader from "react-spinners/ClipLoader";
import SettingPanel from "./Setting_panel";

const AttendanceSummary = () => {
  const {
    fetchStaffs,
    staffs,
    setSelectedStaff,
    attendance,
    attendanceTabDepartments,
    fine,
    overtime,
    setAttendance,
    setAttendanceTabDepartments,
    setFine,
    setOverTime,
    summaryDate,
    setSummaryDate,
  } = useGlobalContext();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        const [departmentsData, fineData, overtimeData] = await Promise.all([
          fetchDepartments(),
          fetchFineDetails(),
          fetchOverTimeDetails(),
        ]);
        setAttendanceTabDepartments(departmentsData.data);
        setFine(fineData);
        setOverTime(overtimeData.data);
      } catch (error) {
        console.error("Error fetching initial data:", error);
      }
    };
    if (attendanceTabDepartments?.length == 0) {
      fetchInitialData();
    }
    // fetchStaffs();
  }, [summaryDate]);

  const fetchAttendance = async () => {
    if (summaryDate) {
      setLoading(true);
      setAttendance([]);
      try {
        const data = await fetchAttendanceDetail(summaryDate);
        setAttendance(data?.records || []);
      } catch (error) {
        console.error("Error fetching attendance details:", error);
        setAttendance([]);
      } finally {
        setLoading(false);
      }
    }
  };
  useEffect(() => {
    if (attendance?.length == 0) {
      fetchAttendance();
    }
  }, [summaryDate]);

  const handleDateChange = (e) => {
    e.preventDefault();
    fetchAttendance();
    setSummaryDate(e.target.value);
  };

  return (
    <div className="p-[20px] w-full work-fine">
      <SettingPanel />
      <Header
        summaryDate={summaryDate}
        handleDateChange={handleDateChange}
        attendance={attendance}
      />
      {loading && (
        <div className="flex justify-center items-center pt-48 h-full">
          <ClipLoader color={"#24007a"} size={50} />
        </div>
      )}
      {!loading && attendance?.length === 0 && (
        <p className="text-red-600 text-[16px] w-full text-center pt-8">
          No staff with salary details found for this month.
        </p>
      )}
      {!loading && (
        <DepartmentList
          departments={attendanceTabDepartments}
          attendance={attendance}
          staffs={staffs}
          setSelectedStaff={setSelectedStaff}
          summaryDate={summaryDate}
          fetchAttendanceDetail={fetchAttendance}
        />
      )}
      {/* {!loading && (
        <OtherDepartments
          attendance={attendance}
          staffs={staffs}
          setSelectedStaff={setSelectedStaff}
          fetchAttendanceDetail={fetchAttendance}
        />
      )} */}
    </div>
  );
};

export default AttendanceSummary;
